import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const useDownloadPDF = () => {
  const sectionRef = useRef<HTMLElement | null>(null);

  const handleDownloadPDF = async () => {
    if (sectionRef.current) {
      try {
        // Temporarily set overflow to visible to capture all content
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "visible";

        // Ensure the entire content is rendered before capturing it
        const canvas = await html2canvas(sectionRef.current, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: true,
          windowWidth: sectionRef.current.scrollWidth,
          windowHeight: sectionRef.current.scrollHeight,
        });

        // Restore the original overflow property
        document.body.style.overflow = originalOverflow;

        const imgData = canvas.toDataURL("image/png");

        // Create a PDF instance
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Scale the image to fit the page dimensions
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Check if the image height exceeds the page height
        if (imgHeight > pageHeight) {
          let position = 0;
          while (position < imgHeight) {
            const remainingHeight = imgHeight - position;
            const currentHeight =
              remainingHeight > pageHeight ? pageHeight : remainingHeight;
            const canvasPart = document.createElement("canvas");
            canvasPart.width = canvas.width;
            canvasPart.height = (canvas.width * currentHeight) / imgWidth;
            const ctx = canvasPart.getContext("2d");
            if (ctx) {
              ctx.drawImage(canvas, 0, -position, canvas.width, canvas.height);
              const imgPartData = canvasPart.toDataURL("image/png");
              pdf.addImage(imgPartData, "PNG", 0, 0, imgWidth, currentHeight);
              position += pageHeight;
              if (position < imgHeight) {
                pdf.addPage();
              }
            }
          }
        } else {
          // Add the image to the PDF
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        }

        // Save the PDF
        pdf.save("section.pdf");
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }
  };

  return { sectionRef, handleDownloadPDF };
};

export default useDownloadPDF;
